import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/app/[locale]/(header-footer)/product/[slug]/@links/UsefulLinks.tsx");
